import { createAction } from '@reduxjs/toolkit';
import { SelectOption } from '../Models/SelectOption';

const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
const SET_PARTS_SEARCH_TEXT = 'SET_PARTS_SEARCH_TEXT';
const SET_MANUFACTURER_LIST = 'SET_MANUFACTURER_LIST';
const SET_MIN_PRICE = 'SET_MIN_PRICE';
const SET_MAX_PRICE = 'SET_MAX_PRICE';

export const setSearchText = createAction<string | null>(SET_SEARCH_TEXT);
export const setPartsSearchText = createAction<string | null>(
  SET_PARTS_SEARCH_TEXT
);
export const setManufacturers = createAction<SelectOption[] | null>(
  SET_MANUFACTURER_LIST
);
export const setMinPrice = createAction<number | null>(SET_MIN_PRICE);
export const setMaxPrice = createAction<number | null>(SET_MAX_PRICE);
